import { UserX } from "lucide-react";

import styles from "./OutOfRosterNotice.module.css";

export const OutOfRosterNotice = () => {
  return (
    <div className={styles.wrapper}>
      <UserX size={52} className={styles.icon} />
      <p className={styles.title}>You are not in roster</p>
      <p className={styles.description}>
        Your appointments are hidden because your account is currently not
        included in the roster.
      </p>
    </div>
  );
};
